// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + chunkId + "." + {"234":"ede9cdd9fcc54868d1b3","238":"2a49172770761339ffd8","681":"adabe847ff3f87615902","917":"be4acb1fe4d22ed3d32b"}[chunkId] + ".bundle.css";
};